export const iconFontAwesomeDesignSplotch = (
	<i className="fa-solid fa-splotch"></i>
);
